'use client';

import { useState } from 'react';
import Input from '../Input';
import Icon from '../Icon';

/** @todo: add support for non-string values */
export function ArrayInput(
    props: {
        value?: string[] | null | undefined;
        onChange?: (values: string[]) => void;
        deleteButtonLabel?: string;
        addButtonLabel?: string;
        editButtonLabel?: string;
        className?: string;
    } & Pick<React.ComponentProps<typeof Input>, 'placeholder'>,
) {
    const [text, setText] = useState('');

    const addItem = () => {
        if (text === '') return;

        if (!props.value?.includes(text)) {
            props.onChange?.(Array.isArray(props.value) ? [...props.value, text] : [text]);
        }
        setText('');
    };

    const removeItem = (index: number) => {
        const newValue = props.value ? [...props.value] : [];

        const [value] = newValue.splice(index, 1);

        props.onChange?.(newValue);

        return value;
    };

    return (
        <div className={props.className}>
            <Input
                value={text}
                onChange={e => setText(e.currentTarget.value)}
                placeholder={props.placeholder}
                onKeyDown={e => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        e.stopPropagation();
                        addItem();
                    }
                }}
                iconAfter={
                    <button
                        type="button"
                        onClick={() => addItem()}
                        className="mr-4 rounded-3xl bg-tertiary text-2xl text-white"
                        title={props.addButtonLabel ?? 'Add item'}
                    >
                        <Icon name="plus" />
                    </button>
                }
            />
            {!!props.value?.length && (
                <ul className="mt-4 flex flex-wrap gap-2 pl-4">
                    {props.value?.map((v, i) => (
                        <li
                            key={`${v}-${i}`}
                            className="flex w-fit cursor-pointer items-center rounded-lg bg-blue-50 text-sm font-medium text-primary transition hover:bg-blue-100"
                        >
                            <button
                                type="button"
                                title={props.editButtonLabel ?? 'Edit item'}
                                className="py-2 pl-4"
                                onClick={e => {
                                    e.stopPropagation();

                                    removeItem(i);
                                    setText(v);
                                }}
                            >
                                {v}
                            </button>
                            <button
                                type="button"
                                className="p-2 text-blue-400 transition hover:text-primary"
                                title={props.deleteButtonLabel ?? 'Delete item'}
                                onClick={e => {
                                    e.stopPropagation();
                                    removeItem(i);
                                }}
                            >
                                <Icon name="trash" size="xs" />
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
